<script>
import api from "@/api";
import { isArchivalEnabled } from "./helpers";
import { ArchivalDisabledMessaging } from "./components";

export default {
  name: "WorkflowArchival",
  components: {
    "archival-disabled-messaging": ArchivalDisabledMessaging,
  },
  props: ["clusterName", "dateFormat", "domain", "timeFormat", "timezone"],
  data() {
    return {
      domainSettings: {},
      loading: true,
    };
  },
  computed: {
    isArchivalEnabled() {
      return isArchivalEnabled(this.domainSettings);
    },
  },
  created() {
    this.getDomainInfo();
  },
  methods: {
    async getDomainInfo() {
      const res = await api.getDomainInfo(this.domain);
      this.loading = false;
      if (res.status === 200 && res.data) {
        this.domainSettings = res.data;
      } else {
        this.error = "查询domain信息失败！";
      }
    },
  },
};
</script>

<template>
  <section class="workflow-archival" :class="{ loading }">
    <archival-disabled-messaging
      v-if="!loading && !isArchivalEnabled"
      :domain-settings="domainSettings"
    />
    <router-view
      v-if="!loading && isArchivalEnabled"
      name="workflow-archival-advanced"
      :cluster-name="clusterName"
      :date-format="dateFormat"
      :domain="domain"
      :time-format="timeFormat"
      :timezone="timezone"
    />
    <router-view
      v-if="!loading && isArchivalEnabled"
      name="workflow-archival-basic"
      :cluster-name="clusterName"
      :date-format="dateFormat"
      :domain="domain"
      :time-format="timeFormat"
      :timezone="timezone"
    />
  </section>
</template>

<style lang="stylus">
section.workflow-archival {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-y: auto;
}
</style>
